import http from "./http";
const invoice = {
  getOne(invoiceId) {
    return http.post(
      "invoice/invoice/getOne?invoiceId=" + invoiceId 
    );
  },

  //作者获取可开具发票的列表
  getListByAuthor(page,size) {
    return http.post(
      "invoice/invoice/getList?page=" + page +"&size="+size
    );
  },

  //编辑获取文章开具发票信息
  getListByEditor(page,size,model) {
    return http.post(
      "invoice/invoice/getList1?page=" + page +"&size="+size,model
    );
  },

  //财务获取文章开具发票信息
  getList(page,size,model) {
    return http.post(
      "invoice/invoice/getList2?page=" + page +"&size="+size,model
    );
  },

  /*填写发票 */
  add(model){
    return http.post("invoice/invoice/insert",model);
  },

  /*更新发票信息 */
  update(model){
    return http.post("invoice/invoice/edit",model);
  }
};
export default invoice;
